module.exports = __webpack_public_path__ + "static/lego-a8291868fe49c40e34f243e0c1e7e020.jpg";